import React from "react";
import { Callout } from "@sscs/ui";

type WarningBoxProps = {
  hasGroupsWithAndWithoutLimit: boolean;
  groupLimitsExceedAnalysisCapacity: boolean;
};

const WarningBox = ({
  hasGroupsWithAndWithoutLimit,
  groupLimitsExceedAnalysisCapacity,
}: WarningBoxProps): React.JSX.Element => {
  return (
    <>
      {hasGroupsWithAndWithoutLimit && (
        <Callout
          type="warning"
          title="Groups without limits exist and can use up the whole analysis capacity"
        >
          To limit their consumption, configure their limits.
        </Callout>
      )}
      {groupLimitsExceedAnalysisCapacity && (
        <Callout
          type="warning"
          title="The total configured limits exceed the organization analysis capacity"
        >
          Adjust your group limits accordingly.
        </Callout>
      )}
    </>
  );
};

export default WarningBox;
